import { AsyncAction } from 'client/actions'
import { Middleware } from 'redux'
import { Action } from 'typescript-fsa'

import { ongoingAdd, ongoingRemove } from '../actions/ongoing'

export default ((store) => (next) => async (action: AsyncAction<any> | Action<any>) => {
  const { type, payload, meta } = action

  if (!meta || !meta.async) {
    return next(action)
  }

  next(ongoingAdd(type))

  try {
    next({ type, payload: await payload() })
  } catch (error) {
    const { errorActionCreator } = meta
    if (errorActionCreator) {
      next(errorActionCreator(error))
    } else {
      next({ type, error: true, payload: error })
    }
  }
  next(ongoingRemove(type))
}) as Middleware
